import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { IonicModule, ModalController, NavParams } from '@ionic/angular';
import { ToastController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { format, isBefore, isEqual } from 'date-fns';
import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
interface Filtro {
  dataInicio: string;
  dataFim: string;
  status: string;
}

@Component({
  selector: 'app-grupo-gerenciar-solicitacoes-filtro',
  templateUrl: './grupo-gerenciar-solicitacoes-filtro.component.html',
  styleUrls: ['./grupo-gerenciar-solicitacoes-filtro.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ReactiveFormsModule,
    ProverDatepickerComponent,
  ],
})
export class GrupoGerenciarSolicitacoesFiltroComponent implements OnInit {
  validations_form: FormGroup;
  filtro: Filtro = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    status: ''
  };

  status = [
    { id: 0, label: this.translate.instant('Todos')},
    { id: 1, label: this.translate.instant('Pendente')},
    { id: 2, label: this.translate.instant('Em Andamento')},
    { id: 3, label: this.translate.instant('Finalizado')},
  ];

  constructor(
    public formBuilder: FormBuilder,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public toastCtrl: ToastController
  ) {
    this.filtro = this.navParams.get('filtro');

    this.validations_form = this.formBuilder.group({
      dataInicio: new FormControl(this.filtro.dataInicio, Validators.required),
      dataFim: new FormControl(this.filtro.dataFim, Validators.required),
      status: new FormControl(this.filtro.status),
    });
  }

  ngOnInit() { }

  async onSubmit(form: any) {
    const result =
      isBefore(new Date(form.dataInicio), new Date(form.dataFim)) ||
      isEqual(new Date(form.dataInicio), new Date(form.dataFim));
        
      if (!result) {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("As datas informadas não atendem aos critérios de validação."),
          duration: 3000,
        });
        
      toast.present();
      return;
    }
    this.modalCtrl.dismiss(form);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
